module.exports = __webpack_public_path__ + "media/images/shopping-cart-917de50df7cd295497ea427d07585d7d.png";